export default "__VITE_ASSET__D_EzdZh9__"